<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-default shape-skew">
          <div class="overlay-bg"></div>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-6">
                <h1 class="display-3 text-white">
                  {{$t('Need_Funds_To ')}}
                  <span>{{$t('We_Can_Chang_Many_Lives')}}</span>
                </h1>
                <p class="lead text-white">{{$t('Home_Message')}}</p>
                <div class="btn-wrapper">
                  <base-button
                    v-b-modal.modal-userInfo
                    tag="a"
                    href="#"
                    class="mb-3 btn-lg btn-donate mb-sm-0"
                    type="white"
                    icon="ni ni-favourite-28"
                  >{{$t('Donate_Now')}}</base-button>
                  <BankDetails :cardData="selectedCard" />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="top-header-card">
                  <b-tabs content-class fill>
                    <b-tab active>
                      <template v-slot:title>{{$t('Spend_Monthly')}}</template>
                      <div class="card-details">
                        <!-- <div class="org-spend">
                                    <div class="org-name"> {{$t('Monthly_Organizations_Spend')}} : <span>&#8381; {{this.monthlySpendStats.organization_monthly_spend}}</span></div>
                        </div>-->
                        <b-button class="project-btn" block v-b-toggle.collapse-1 variant="primary">
                          {{$t('Monthly_Project_Spend')}} :
                          <span>&#8381;{{this.monthlySpendStats.campaign_monthly_spend}}</span>
                          <i class="fa fa-chevron-down"></i>
                        </b-button>
                        <b-collapse id="collapse-1" visible class="cllapse-list">
                          <b-table
                            sticky-header="260px"
                            small
                            responsive
                            striped
                            hover
                            :items="items"
                            :fields="fields"
                            @row-clicked="myRowClickHandler"
                          >
                            <template
                              v-slot:cell(campaign_name)="data"
                            >{{ data.item && data.item.campaign_name ? data.item.campaign_name : "NA"}}</template>
                          </b-table>
                        </b-collapse>
                        <div class="top-card-footer">
                          <b-link class="view-btn" to="/donator-details">{{$t('View_All')}}</b-link>
                        </div>
                      </div>
                    </b-tab>
                    <b-tab>
                      <template v-slot:title>{{$t('Top_Donation')}}</template>
                      <div class="card-details">
                        <b-table
                          sticky-header="312px"
                          small
                          responsive
                          striped
                          hover
                          :items="items1"
                          :fields="fieldsTopDonation"
                        ></b-table>
                        <div class="top-card-footer">
                          <b-link class="view-btn" to="/donator-details">{{$t('View_All')}}</b-link>
                        </div>
                      </div>
                    </b-tab>
                    <b-tab>
                      <template v-slot:title>{{$t('Recent_Donation')}}</template>
                      <div class="card-details">
                        <b-table
                          sticky-header="312px"
                          small
                          responsive
                          striped
                          hover
                          :items="items2"
                          :fields="fieldsRecentDonation"
                        >
                          <template
                            v-slot:cell(payee_name)="data"
                          >{{ data.item && data.item.payee_name ? data.item.payee_name : "NA"}}</template>
                        </b-table>
                        <div class="top-card-footer">
                          <b-link class="view-btn" to="/donator-details">{{$t('View_All')}}</b-link>
                        </div>
                      </div>
                    </b-tab>
                  </b-tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
    <section class="section pt-lg-0 mt--200">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <h3 class="black-h3">
              <span
                class="icon icon-shape bg-gradient-white icon-lg shadow mr-2 rounded-circle text-success"
              >
                <i class="ni ni-building"></i>
              </span>
              {{$t('Running_Projects')}}
            </h3>
            <div v-if="this.runningProjects.length <=0">
              <h3 class="no-project">{{$t('No_Projects_Available')}}</h3>
            </div>
            <div class="row row-grid">
              <div class="col-lg-4" v-for="(project,index) in runningProjects" :key="index">
                <ProjectCard
                  v-bind:cardData="project"
                  @updateSelectedCardData="updateSelectedCardData"
                />
              </div>

              <div class="col-lg-12">
                <div class="view-all">
                  <b-link
                    v-if="this.runningProjects.length >0"
                    type="primary"
                    :to="{ path: '/Projects', query: {p: 'RUNNING' } }"
                  >
                    {{$t('View_More')}}
                    <i class="fa fa-long-arrow-right"></i>
                  </b-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section section-lg pt-0">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-12">
            <h3>
              <icon
                name="fa fa-handshake-o"
                class="mb-5 mr-2"
                size="lg"
                type="success"
                shadow
                rounded
              ></icon>
              {{$t('In_Queue_Projects')}}
            </h3>
            <div v-if="this.inQueueProjects.length <=0">
              <h3 class="no-project">{{$t('No_Projects_Available')}}</h3>
            </div>
            <div class="row row-grid">
              <div class="col-lg-4" v-for="(project,index) in inQueueProjects" :key="index">
                <ProjectCard
                  v-bind:cardData="project"
                  @updateSelectedCardData="updateSelectedCardData"
                />
              </div>

              <div class="col-lg-12">
                <div class="view-all">
                  <b-link
                    v-if="this.inQueueProjects.length >0"
                    type="primary"
                    :to="{ path: '/Projects', query: {p: 'IN-QUEUE' } }"
                  >
                    {{$t('View_More')}}
                    <i class="fa fa-long-arrow-right"></i>
                  </b-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg pt-0">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-12">
            <h3>
              <icon name="fa fa-smile-o" class="mb-5 mr-2" size="lg" type="success" shadow rounded></icon>
              {{$t('Completed_Projects')}}
            </h3>
            <div v-if="this.completedProjects.length <=0">
              <h3 class="no-project">{{$t('No_Projects_Available')}}</h3>
            </div>
            <div class="row row-grid">
              <div class="col-lg-4" v-for="(project,index) in completedProjects" :key="index">
                <ProjectCard
                  v-bind:cardData="project"
                  @updateSelectedCardData="updateSelectedCardData"
                />
              </div>
              <div class="col-lg-4"></div>
              <div class="col-lg-4"></div>
              <div class="col-lg-12">
                <div class="view-all">
                  <b-link
                    v-if="this.completedProjects.length >0"
                    type="primary"
                    :to="{ path: '/Projects', query: {p: 'COMPLETED' } }"
                  >
                    {{$t('View_More')}}
                    <i class="fa fa-long-arrow-right"></i>
                  </b-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg pt-0">
      <div class="container">
        <card gradient="warning" no-body shadow-size="lg" class="border-0">
          <div class="p-5">
            <div class="row align-items-center">
              <div class="col-lg-8">
                <h3 class="text-white">{{$t('Supporting_A_Good_Cause')}}</h3>
                <p class="lead text-white mt-3">{{$t('Good_Cause')}}.</p>
              </div>
              <div class="col-lg-3 ml-lg-auto">
                <base-button
                  v-b-modal.modal-userInfo
                  type="white"
                  block
                  size="lg"
                >{{$t('Donate_Now')}}</base-button>
              </div>
            </div>
          </div>
        </card>
      </div>
    </section>
    <section id="how-work" class="section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-3 bg-gradient-default shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container pb-200">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3 text-white">{{$t('How_It_Works')}}</h2>
            <p class="lead text-white">{{$t('How_It_Work_Sub_Title')}}</p>
          </div>
        </div>
        <div class="row row-grid mt-5">
          <div class="col-lg-4">
            <div class="how-work-icon">
              <img src="img/ill/collaboration.svg" />
            </div>
            <h5 class="text-white mt-3">{{$t('Start_Campaigns')}}</h5>
            <p class="text-white mt-3">{{$t('How_Info_1')}}.</p>
          </div>
          <div class="col-lg-4">
            <div class="how-work-icon">
              <img src="img/ill/bank.svg" />
            </div>
            <h5 class="text-white mt-3">{{$t('Collect_Funds')}}</h5>
            <p class="text-white mt-3">{{$t('How_Info_2')}}.</p>
          </div>
          <div class="col-lg-4">
            <div class="how-work-icon">
              <img src="img/ill/help.svg" />
            </div>
            <h5 class="text-white mt-3">{{$t('Help_People')}}</h5>
            <p class="text-white mt-3">{{$t('How_Info_3')}}.</p>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg pt-lg-0 pb-lg-0">
      <div class="container">
        <div class="row row-grid justify-content-center">
          <div class="col-lg-8 text-center">
            <h2 class="display-3">{{$t('About_Charity_Organizations')}}</h2>
            <p class="lead">{{$t('About_Org_Info')}}</p>
            <div class="btn-wrapper">
              <base-button
                v-b-modal.modal-userInfo
                class="btn btn-primary mb-3 mb-sm-0"
              >{{$t('Donate_Now')}}!</base-button>
            </div>
            <div class="text-center">
              <img class="donation-about-image" src="img/about.jpg" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import BankDetails from "./components/BankDetails";
import ProjectCard from "./components/ProjectCard";
import axios from "axios";
export default {
  name: "home",
  components: {
    BankDetails,
    ProjectCard
  },
  methods: {
    updateSelectedCardData(_data) {
      this.selectedCard = _data;
    },

    myRowClickHandler(record, index) {
      if (record.id) {
        let location = `/Project-details?q=${record.id}`;
        this.$router.push(location);
      }

      console.log("record is campagn", record);
    },
    tCol(colName) {
      return this.$t(".fields." + colName + ".label");
    },
    getDashboardProjectList() {
      var urlWithService =
        process.env.VUE_APP_API_URL + `/campaigns/default/dashboard?`;
      const token = localStorage.getItem("token");
      axios({
        method: "get",
        url: urlWithService,
        headers: { Authorization: ` ${token}` }
      })
        .then(Response => {
          if (Response) {
            this.runningProjects = Response.data.running || [];
            this.inQueueProjects = Response.data.in_queue || [];
            this.completedProjects = Response.data.completed || [];
            this.monthlySpendStats = Response.data.monthly_spend_stats || {};
            this.items = Response.data.monthly_spend_campaigns || [];
            this.items1 = Response.data.top_donations || [];
            this.items2 = Response.data.recent_donations || [];
          }
        })
        .catch();
    }
  },
  mounted() {
    this.getDashboardProjectList();
  },
  computed: {
    fields() {
      return [
        { key: "campaign_name", label: this.$t("Project_name") },
        { key: "spend_amount", label: this.$t("Spent_Amount") }
      ];
    },
    fieldsTopDonation() {
      return [
        { key: "payee_name", label: this.$t("Payee_Name") },
        { key: "amount", label: this.$t("Amount") }
      ];
    },
    fieldsRecentDonation() {
      return [
        { key: "payee_name", label: this.$t("Payee_Name") },
        { key: "amount", label: this.$t("Amount") }
      ];
    }
  },
  data() {
    return {
      selectedCard: null,

      items: [],
      //  fields: "",
      items1: [],
      //  fieldsTopDonation:['payee_name','amount'],
      items2: [],
      // fieldsRecentDonation:['payee_name','amount'],
      projectName: {},
      runningProjects: [],
      completedProjects: [],
      inQueueProjects: [],
      monthlySpendStats: {},

      // items2: [],
      // fieldsRecentDonation: ["payee_name", "amount"],
      projectName: {},
      runningProjects: [],
      completedProjects: [],
      inQueueProjects: [],
      monthlySpendStats: {}
    };
  }
};
</script>
